const COMPANY_ID_KEY = "__company_id";
const CUSTOMER_GROUP_KEY = "__from_cart_customer_group";
const CAMPAIGN_ID_KEY = "__iterable_campaign_id";

const getIterableCampaignId = () => {
  const params = new URLSearchParams(window.location.search);
  const campaignId = params.get("iterable_campaign");

  if (campaignId && /^\d+$/.test(campaignId)) {
    return campaignId;
  }

  return null;
};

const updateCompanyIdCartAttribute = () => {
  window.loadInitialCart.then(() => {
    const targets = [
      {
        expected: window.theme.company_id,
        key: COMPANY_ID_KEY,
      },
      {
        expected: window.theme.customer_group,
        key: CUSTOMER_GROUP_KEY,
      },
    ];

    const iterableCampaignId = getIterableCampaignId();

    if (iterableCampaignId) {
      targets.push({
        expected: iterableCampaignId,
        key: CAMPAIGN_ID_KEY,
      });
    }

    const updateRequired = targets.some(({ expected, key }) => {
      const saved = window.cartData?.attributes?.[key] || "";
      return saved !== expected;
    });

    if (updateRequired) {
      const attributes = Object.fromEntries(
        targets.map(({ expected, key }) => [key, expected]),
      );
      window.updateCart({
        attributes,
      });
    }
  });
};

updateCompanyIdCartAttribute();

document.addEventListener("cart:updated", updateCompanyIdCartAttribute);
